import { BaseSession } from './BaseSession'
import { i18n } from '@/libs/i18n'

class LoginSession extends BaseSession {
  get location() {
    const { ip, city, country } = this.model.location
    return {
      ip,
      city: city || i18n.global.t('settings.security.unknownCity'),
      country: country || i18n.global.t('settings.security.unknownCountry'),
    }
  }

  get os() {
    return this.model.os || i18n.global.t('settings.security.unknownOs')
  }

  get slotList() {
    return [
      this.location.ip,
      this.location.city,
      this.location.country,
      this.os,
      this.device,
      this.updatedAt.fromNow(),
    ]
  }
}

export const LoginSessionDecorator = (session) => {
  return new LoginSession(session)
}
